var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "blueNews" }, [
    _c("div", { staticClass: "banner" }, [
      _c(
        "div",
        { staticClass: "s_w" },
        [_c("Search", { on: { toSsearch: _vm.toSsearch } })],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "news" }, [
      _c("div", { staticClass: "bjsptnewslistw" }, [
        _c("div", { staticClass: "locationBox" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/icon-position.png") },
          }),
          _vm._v(" "),
          _c("div", [
            _vm._v("您当前位置: 新闻公告 > "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.curIndex != null ? _vm.tabList[_vm.curIndex].type : "全部"
                )
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.tabList, function (i, j) {
            return _c(
              "div",
              {
                staticClass: "item",
                class: { active: _vm.curIndex == j },
                on: {
                  click: function ($event) {
                    return _vm.tabs(i, j)
                  },
                },
              },
              [_vm._v(_vm._s(i.type))]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "newsList",
          },
          [
            _c("div", { staticClass: "listBox" }, [
              _vm.list.length > 0
                ? _c(
                    "div",
                    { staticClass: "list listPage" },
                    _vm._l(_vm.list, function (i) {
                      return _c("div", { staticClass: "listItem" }, [
                        _c("div", { staticClass: "time" }, [
                          _c("div", { staticClass: "day" }, [
                            _vm._v(_vm._s(_vm._f("day")(i.createTime))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "year" }, [
                            _vm._v(_vm._s(_vm._f("year")(i.createTime))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tit",
                            on: {
                              click: function ($event) {
                                return _vm.lookDetail(i)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(i.newsTitle))])]
                        ),
                      ])
                    }),
                    0
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "100px",
                        "text-align": "center",
                        width: "100%",
                      },
                    },
                    [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                  ),
            ]),
            _vm._v(" "),
            _vm.total > 0
              ? _c(
                  "div",
                  { staticClass: "paginationX" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.query.pageNum,
                        "page-size": _vm.query.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.total,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }